module.exports = __webpack_public_path__ + "static/media/atm.5e2f1479.png";